export default __webpack_public_path__ + "static/media/Blog12.11.115c82af.png";